import React from 'react';
import { ClipLoader } from 'react-spinners';
import styles from './styles.module.scss';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'success' | 'minimal';
  text?: string;
  fullScreen?: boolean;
  showPulse?: boolean;
}

// Color mapping for variants
const colorMap: Record<string, string> = {
  primary: '#0d6efd',
  secondary: '#6c757d',
  success: '#198754',
  minimal: '#183E3E'
};

// Size mapping (in pixels)
const sizeMap: Record<string, number> = {
  sm: 35,
  md: 50,
  lg: 70
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  variant = 'success',
  text = 'Loading...',
  fullScreen = false,
  showPulse = true,
}) => {
  const spinnerSize = sizeMap[size];
  const spinnerColor = colorMap[variant];

  const content = (
    <div className={styles.spinnerContainer}>
      <ClipLoader
        color={spinnerColor}
        size={spinnerSize}
        speedMultiplier={1}
        loading={true}
        cssOverride={{
          display: 'block',
          margin: '0 auto'
        }}
      />
      {text && (
        <div className={styles.textContainer}>
          <p className={styles.loadingText}>{text}</p>
          {showPulse && (
            <div className={styles.dots}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className={styles.fullScreenLoader}>
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;
